import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  FormControl,
  Card,
  CardContent
} from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'
import SettingsIcon from '@mui/icons-material/Settings'
import CloudIcon from '@mui/icons-material/Cloud'
import { EMAIL_ACCOUNT_TYPES } from '../../../utils/campaignConstants'

const AccountTypeSelector = ({ accountType, originalAccountType, onChange }) => {
  const { t } = useTranslation()

  const showExternalServiceOption = originalAccountType === EMAIL_ACCOUNT_TYPES.EXTERNAL_SERVICE

  return (
    <Box sx={{ mb: 4 }}>
      <FormControl component="fieldset" sx={{ width: '100%' }}>
        <RadioGroup
          value={accountType}
          onChange={onChange}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 3,
            justifyContent: 'space-between'
          }}
        >
          <Card
            variant="outlined"
            sx={{
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 3,
              flex: 1,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.02)'
              }
            }}
            onClick={() => onChange({ target: { value: EMAIL_ACCOUNT_TYPES.USERNAME_PASSWORD } })}
          >
            <CardContent sx={{ py: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                <Radio
                  checked={accountType === EMAIL_ACCOUNT_TYPES.USERNAME_PASSWORD}
                  onChange={onChange}
                  value={EMAIL_ACCOUNT_TYPES.USERNAME_PASSWORD}
                />
                <SettingsIcon sx={{ color: 'primary.main' }}/>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.9rem' }}>
                    {t('mailTemplate.users.modal.manualConfiguration')}
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'text.primary', opacity: 0.7, mt: 0.2, display: 'block' }}>
                    {t('mailTemplate.users.modal.manualDescription')}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          <Card
            variant="outlined"
            sx={{
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 3,
              flex: 1,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.02)'
              }
            }}
            onClick={() => onChange({ target: { value: EMAIL_ACCOUNT_TYPES.GMAIL_OAUTH2 } })}
          >
            <CardContent sx={{ py: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                <Radio
                  checked={accountType === EMAIL_ACCOUNT_TYPES.GMAIL_OAUTH2}
                  onChange={onChange}
                  value={EMAIL_ACCOUNT_TYPES.GMAIL_OAUTH2}
                />
                <EmailIcon sx={{ color: 'primary.main' }}/>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.9rem' }}>
                    {t('mailTemplate.users.modal.connectWithGmail')}
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'text.primary', opacity: 0.7, mt: 0.2, display: 'block' }}>
                    {t('mailTemplate.users.modal.gmailDescription')}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>

          {showExternalServiceOption && (
            <Card
              variant="outlined"
              sx={{
                cursor: 'not-allowed',
                transition: 'all 0.2s ease-in-out',
                border: '1px solid',
                borderColor: accountType === EMAIL_ACCOUNT_TYPES.EXTERNAL_SERVICE ? 'primary.main' : 'divider',
                borderRadius: 3,
                flex: 1,
                backgroundColor: accountType === EMAIL_ACCOUNT_TYPES.EXTERNAL_SERVICE ? 'rgba(25, 118, 210, 0.04)' : 'transparent'
              }}
            >
              <CardContent sx={{ py: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                  <Radio
                    checked={accountType === EMAIL_ACCOUNT_TYPES.EXTERNAL_SERVICE}
                    disabled
                    value={EMAIL_ACCOUNT_TYPES.EXTERNAL_SERVICE}
                  />
                  <CloudIcon sx={{ color: 'primary.main' }}/>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.9rem' }}>
                      {t('mailTemplate.users.modal.externalService')}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.primary', opacity: 0.7, mt: 0.2, display: 'block' }}>
                      {t('mailTemplate.users.modal.externalServiceDescription')}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          )}
        </RadioGroup>
      </FormControl>
    </Box>
  )
}

export default AccountTypeSelector
